<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import Multiselect from 'vue-multiselect';
import moment from "moment";
import Calendar from '../views/calendario';

/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, Calendar  },
    data() {
        return {
            title: "Inicio",
            items: [
                {
                text: "Inicio",
                href: "/"
                }
            ],
            paginatedData:[],
            colegioseleccionada: null,
            datoscolegios: [
            ],
            isLoading: false,
            eventos:[],
            asignados:[]
        };
    },
    methods:{
        crear(tipo){
            localStorage.setItem('usuario',tipo);
            window.location.href = "/web/configuracion/crearusuario";
        },
        ver_evento(evento){
            localStorage.setItem('evento_codigo',evento);
            window.location.href = "/web/configuracion/eventos";
        },
        ver_colegio(rbd){
            localStorage.setItem('rbd_colegio',rbd);
            window.location.href = "/web/configuracion/colegios";
        },
        customLabel(colegio) {
            return `${colegio.rbd} - ${colegio.nombre}`;
        },
        fetchColegios(query) {
            if (query.length < 3) return; // Buscar después de escribir al menos 3 letras
            this.isLoading = true;
            axios.get(`/api/colegios?search=${query}`)
                .then(response => {
                this.datoscolegios = response.data;
                })
                .catch(error => console.error(error))
                .finally(() => this.isLoading = false);
        },
        buscarColegio() {
            console.log('Colegio seleccionado:', this.colegioseleccionada);
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY HH:mm');
            return orden
        },
    },
    created(){
        this.isLoading=true
        axios.get(`/api/get_colegios`).then(response => {
            if(response.data.estado){
                this.datoscolegios = response.data.colegios;
                this.asignados = response.data.colegios.filter((item) => 
                    item.user_id==this.user.id
                );
            }
        }
        ).catch(error => console.error(error)
        ).finally(() => this.isLoading = false);
        axios.get('/api/get_proximos_eventos').then(res=>{
            this.eventos=res.data.eventos;
        });
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-4">
                <div class="card shadow-lg">
                    <div class="card-body">
                        <div class="float-right dropdown ml-2">
                            <!-- <a class="text-muted dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="mdi mdi-dots-horizontal font-size-18"></i>
                            </a> -->

                            <!-- <div class="dropdown-menu dropdown-menu-right">
                                <a class="dropdown-item" href="#">Action</a>
                                <a class="dropdown-item" href="#">Another action</a>
                                <a class="dropdown-item" href="#">Something else here</a>
                            </div> -->
                        </div>
                        <div>
                            <div class="mb-4 mr-3">
                                <i class="mdi mdi-account-circle text-primary h1"></i>
                            </div>

                            <div class="mb-4">
                                <h5>{{this.user.name}}</h5>
                                <p class="text-muted mb-1">
                                    {{this.user.email}}
                                </p>
                                <p class="text-muted mb-0">Sede: {{this.user.sede}}</p>
                                <p class="text-muted mt-3 font-size-14" v-if="user.rol!='Laborante'">Nº colegios asignados: {{ this.asignados.length }}  </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-8" v-if="user.rol!='Laborante'">
                <div class="card shadow-lg text-center">
                    <div class="card-body">
                        <b-button class="mb-2" variant="primary" href="/web/configuracion/crearevento">Crear Eventos</b-button>
                        <b-button class="mb-2" variant="primary" @click="crear('usuario')" v-if="user.rol=='Admin'">Crear Usuarios</b-button>
                        <b-button class="mb-2" variant="primary" @click="crear('laborante')" v-if="user.rol=='Admin'">Crear Laborante</b-button>
                    </div>
                </div>
                <div class="card shadow-lg">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <label for="title">Buscar Colegio</label>
                                <p>Ingrese nombre o RBD</p>
                                <div class="row">
                                    <div class="col-md-10">
                                        <multiselect
                                            v-model="colegioseleccionada"
                                            :options="datoscolegios"
                                            :searchable="true"
                                            :loading="isLoading"
                                            :custom-label="customLabel"
                                            placeholder="Buscar colegio..."
                                            @search-change="fetchColegios"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                        >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                    </multiselect>
                                    </div>
                                    <div class="col-md-2">
                                    <b-button variant="primary" :disabled="!colegioseleccionada" block @click="ver_colegio(colegioseleccionada.rbd)">Ver</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12" v-if="user.rol!='Laborante'">
                <div class="card">
                    <div class="card-body">
                        <Calendar/>
                    </div>
                </div>
                <!-- <div class="card shadow-lg">
                    <div class="card-body">
                        <h5>Próximos eventos</h5>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th style="width: 10%;">Código</th>
                                        <th style="width: 30%;">Actividad</th>
                                        <th style="width: 15%;">Fecha Inicio</th>
                                        <th style="width: 25%;">Colegio</th>
                                        <th style="width: 10%;">Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ev,index) in eventos" :key="index">
                                        <td>{{ ev.codigo }}</td>
                                        <td>{{ ev.nombre_difusion }}</td>
                                        <td>{{ formatFecha(ev.fecha_inicio) }}</td>
                                        <td>{{ ev.colegio }}</td>
                                        <td>
                                            <b-button variant="primary" @click="ver_evento(ev.codigo)">Ver</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </Layout>
</template>